/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import Axios from '@auth/vue-share/utility/axios';
import gravatar from 'gravatar';
import { useApplicationStore } from '@/stores/application';

export const useUsersStore = defineStore('users', {
    state: () => ({
        users: undefined,
        page: {
            id: 1,
            total: 0,
            size: 10000,
            //size: 25,
            search: undefined,
            users: []
        }
    }),
    getters: {
        getPage: (state) => state.page,
        getUserAvatar: () => {
            return (email) => gravatar.url(email, { default: 'identicon' });
        }
    },
    actions: {
        async fetchPage(page, search) {
            const applicationStore = useApplicationStore();
            applicationStore.setLoading(true);

            const pagePayload = {
                page: page <= 0 ? 0 : Number(page) - 1,
                size: this.page.size
            };

            if (search) pagePayload.search = search;

            await Axios.post('users/page', '/api/users/page', pagePayload).then((response) => {
                const data = response.data;
                this.page.id = data.page;
                this.page.total = data.total;
                this.page.users = data.values;

                applicationStore.setLoading(false);
            });
        },
        async getUser(user_id) {
            return Axios.get('users/user', `/api/users/${user_id}`);
        },
        updateUser(user) {
            return Axios.patch('user/update', `/api/users/${user._id}`, user);
        },
        async createUser(user) {
            return Axios.post('users/create', '/api/users', user);
        },
        deleteUser(user_id) {
            return new Promise((resolve, reject) => {
                Axios.delete('users/delete', `/api/users/${user_id}`)
                    .then(() => {
                        const index = this.page.users.findIndex((user) => user._id === user_id);

                        if (index !== -1) this.page.users.splice(index, 1);

                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
});
